import pro from '../assets/pro.png'
import pro1 from '../assets/crypto.png'
import pro2 from '../assets/foodie.png'
import pro3 from '../assets/Wa.png'
import pro5 from '../assets/tumor.png'
import pro4 from '../assets/fake.webp'
import pro6 from '../assets/progress.webp'
import pro7 from '../assets/data.jpg'
import pro8 from '../assets/fpga.jpg'
import pro9 from '../assets/btrade.png'
const ProjectCardData=[
   

    {
        imgsrc:pro2,
        title:"Ominfood",
        text:"A clone of website called Omnifood using HTML, CSS, JavaScript, Jquery. Omnifood is a premium food delivery service with the mission to bring affordable and healthy meals to as many people as possible. I have cloned the Home landing page of this website and hosted it on netlify .Click on the below icons to see the Source code and hosted website.",
        view:"https://jovial-dragon-4687dc.netlify.app/",
        source:"https://github.com/Nikhil201ec131/Omnifood"

    },

    {
        imgsrc:pro1,
        title:"Coindeko",
        text:"A Cryptocurrencies web application build using REACT and coinranking API integration. In this project one can see real time crypto prices along with charts data.These live charts are build using integration of API data and chart.js library.All GLOBAL STATS including 100+ cryptocurrencies, daily trending News, all Exchanges are being listed time to time automatically using API. I personally use my web app to check updates in crypto market.Click below to see more....",
        view:"https://coindeko-madhuanla-nikhil-nitk.netlify.app/",
        source:"https://github.com/Nikhil201ec131/Coindeko"

    },

    {
        imgsrc:pro3,
        title:"Weather-App",
        text:`In this project I created a weather app using HTML CSS JavaScript , which uses an API from WeatherApi which is available on Rapidapi website to get weather information in our current location we are present. This app shows the temperature of day and night, humidity, sunrise, sunset timings and changes the icon according to the current weather status. In this app one can see future weather forcaste for day and night temperature. Click below to see hosted website`,
        view:"https://weather-madhunalanikhil-nitk.netlify.app/",
        source:"https://github.com/Nikhil201ec131/webapp",

    },

    {
        imgsrc:pro4,
        title:"Fake News Prediction",
        text:"A Python code written using Machine Learning algorithm i.e Linear Regression. In the Project a dataset of fake news is collected from kaggle and performed linear regression model on it to predict whether a given news is Fake or Real which returns a value:'0' for real and value:'1' for Fake ",
        view:"https://github.com/Nikhil201ec131/FakeNewsPrediction",
        source:"https://github.com/Nikhil201ec131/FakeNewsPrediction"

    },
    {
        imgsrc:pro5,
        title:"Kidney Tumor Detection",
        text:"Build a Model for Tumor segmentation in the Kidney that will help medical experts to have a support system that can automatically and accurately segment tumors in the kidney if a kidney is having malignant cell presence. The model is build using 3D-Net architecture and trained on 300 CT of Kits19 images of kidney tumor dataset. Click below to see more....",
        view:"https://github.com/Nikhil201ec131/Kidney_Tumor_detection",
        source:"https://github.com/Nikhil201ec131/Kidney_Tumor_detection"

    },
    {
        imgsrc:pro7,
        title:"Data Compression on FPGA",
        text:"Implemented Data compression on the FPGA using Verilog Hardware description language.Created a Verilog model for two kinds of lossless data compression algorithms i.e Huffman compression and Shanon fano algorithm, Compared the performances and implemented the Huffman algorithm on the FPGA.",
        view:"https://github.com/Nikhil201ec131/Data-Compression-on-FPGA.git",
        source:"https://github.com/Nikhil201ec131/Data-Compression-on-FPGA.git"

    },

    {
        imgsrc:pro8,
        title:"FFT for OFDM on FPGA",
        text:"build a 64-point FFT (Fast Fourier Transform) architecture using two 8-point FFT blocks that can fulfill the requirement for Wireless LAN where each FFT/IFFT operation must be completed under less time. This architecture consumes less silicon area and results in considerable reduction in cost. For computation of IFFT/FFT full parallel scheme is adopted there by making it very fast. Complex multiplication constant are calculated using shift and add operation there by reducing area and power consumption as compared to multiplier",
        view:"",
        source:""

    },

    {
        imgsrc:pro6,
        title:"Task Manager",
        text:"Comming soon....",
        view:"",
        source:""

    },
    {
        imgsrc:pro9,
        title:"Blockchain Based Trading System",
        text:"Comming soon....",
        view:"",
        source:""

    },
   

];

export default ProjectCardData;